import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'

export interface FAQQuestion {
    question: string
    answer: string
}

export interface FAQData {
    title: string
    questions: FAQQuestion[]
}

export interface FAQResponse {
    faq_data: {
        en: FAQData
        ar: FAQData
    }
}

// Dynamic baseUrl: use local file in development, hosted URL in production
// Can be overridden with NEXT_PUBLIC_WALLET_FAQ_URL environment variable
const getFAQUrl = () => {
    if (process.env.NEXT_PUBLIC_WALLET_FAQ_URL) {
        return process.env.NEXT_PUBLIC_WALLET_FAQ_URL
    }
    const isDevelopment = process.env.NODE_ENV === 'development'
    return isDevelopment ? '/json/wallet/qna-wallet.json' : 'https://ui.cltp.co/json/wallet/qna-wallet.json'
}

const baseQueryWithRetry = retry(
    fetchBaseQuery({
        baseUrl: '',
        prepareHeaders: headers => {
            headers.set('Accept', 'application/json')
            headers.set('Content-Type', 'application/json')
            headers.set('Cache-Control', 'no-cache')
            return headers
        }
    }),
    {
        maxRetries: 0
    }
)

export const walletFAQApi = createApi({
    reducerPath: 'walletFAQApi',
    baseQuery: baseQueryWithRetry,
    tagTypes: ['WalletFAQ'],
    endpoints: builder => ({
        getWalletFAQ: builder.query<FAQResponse, void>({
            query: () => ({
                url: getFAQUrl(),
                method: 'GET'
            }),
            providesTags: ['WalletFAQ']
        })
    })
})

export const { useGetWalletFAQQuery } = walletFAQApi
export default walletFAQApi
